import React from "react";
import { Row, Col, Container } from "reactstrap";
import Carousel from "../../components/Carousel/Carousel";
import styles from "./LandmarkCases.module.scss";

export default function LandmarkCases({
  headline,
  description,
  carousels = [],
  isSave,
}) {
  return (
    <div
      style={{
        backgroundColor: "#222221",
        width: "100vw",
        marginLeft: " calc(-50vw + 50%)",
        paddingTop: "74px",
        paddingBottom: "40px",
      }}
    >
      <Container>
        <Row
          style={{
            color: "white",
            marginBottom: "74px",
          }}
        >
          <Col xs="12" md="6">
            <h2 className={styles.mainHeading}>{headline}</h2>
          </Col>
          <Col xs="12" sm="6">
            <p className={styles.description}>{description}</p>
          </Col>
        </Row>

        {!isSave
          ? carousels.map((carousel: any, index) => (
              <Carousel
                id={`carousel-${index}`}
                key={`carousel-${index}`}
                headline={carousel.headline}
                publications={carousel.publications}
                variant="what-we-do"
              />
            ))
          : null}
      </Container>
    </div>
  );
}
